import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export const CategorizationWidgetSkeleton = () => (
  <div className='box-border w-full h-[536px] rounded-[12px] flex px-[24px] pt-[30px] pb-[30px] flex-col items-center justify-between'>
    <SkeletonTheme baseColor='#DFE2EB'>
      <div>
        <div className='h-[11px] leading-3'>
          <Skeleton width='212px' height='11px' borderRadius='13px' count={1} />
        </div>
        <div className='h-[11px] leading-3 mt-[12px]'>
          <Skeleton width='212px' height='11px' borderRadius='13px' count={1} />
        </div>
      </div>
      <div className='h-[236px] leading-3 mt-[72px]'>
        <Skeleton width='230px' height='236px' borderRadius='13px' count={1} />
      </div>
      <div>
        <div className='h-[11px] leading-3 mt-[72px]'>
          <Skeleton width='212px' height='11px' borderRadius='13px' count={1} />
        </div>
        <div className='h-[11px] leading-3 mt-[12px]'>
          <Skeleton width='212px' height='11px' borderRadius='13px' count={1} />
        </div>
      </div>
    </SkeletonTheme>
  </div>
);
